import { BASE_URL, handleResponse } from '@helpers/api';

export const widgetsService = {
    getReviews,
};

function getReviews(widgetKey, body) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    };
    return fetch(`${BASE_URL}api/widgets/${widgetKey}/reviews`, requestOptions).then(handleResponse);
}
